import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function EditChildModal({
  open,
  onOpenChange,
  editForm,
  setEditForm,
  editOtpSent,
  editOtp,
  setEditOtp,
  editLoading,
  requestEditOTP,
  submitEditChanges,
  updateChildBoard
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Child Details</DialogTitle>
          <DialogDescription>Update your child's information. OTP verification required.</DialogDescription>
        </DialogHeader>
        {!editOtpSent ? (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium">Name</label>
                <Input value={editForm.name} onChange={(e) => setEditForm({...editForm, name: e.target.value})} />
              </div>
              <div>
                <label className="text-sm font-medium">Age</label>
                <Input type="number" value={editForm.age} onChange={(e) => setEditForm({...editForm, age: e.target.value})} />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium">Grade</label>
                <Input type="number" value={editForm.grade} onChange={(e) => setEditForm({...editForm, grade: e.target.value})} />
              </div>
              <div>
                <label className="text-sm font-medium">School</label>
                <Input value={editForm.school_name} onChange={(e) => setEditForm({...editForm, school_name: e.target.value})} />
              </div>
            </div>
            <div>
              <label className="text-sm font-medium">Subjects</label>
              <Input value={editForm.subjects_required} onChange={(e) => setEditForm({...editForm, subjects_required: e.target.value})} />
            </div>
            <div className="rounded-lg border border-emerald-100 bg-emerald-50/60 p-3">
              <label className="text-sm font-medium text-emerald-900">Curriculum Board</label>
              <p className="text-xs text-emerald-700 mb-2">Switches instantly — no verification needed.</p>
              <select
                value={editForm.board || "cbse"}
                onChange={(e) => updateChildBoard && updateChildBoard(e.target.value)}
                data-testid="edit-child-board-select"
                className="w-full rounded-md border border-emerald-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
              >
                <option value="cbse">CBSE</option>
                <option value="ib">IB (International Baccalaureate)</option>
              </select>
              <p className="text-[11px] text-emerald-700/70 mt-1">
                Content is aligned to the selected board to the best of our ability; occasional variations from the official syllabus may occur.
              </p>
            </div>
            <Button onClick={requestEditOTP} disabled={editLoading} className="w-full">
              {editLoading ? "Sending..." : "Send Verification OTP"}
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <p className="text-sm text-gray-600">Enter the 6-digit code sent to your email</p>
            <Input 
              value={editOtp} 
              onChange={(e) => setEditOtp(e.target.value)} 
              placeholder="Enter OTP"
              maxLength={6}
              className="text-center text-2xl tracking-widest"
            />
            <Button onClick={submitEditChanges} disabled={editLoading} className="w-full">
              {editLoading ? "Saving..." : "Save Changes"}
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
